import { Icon } from '@iconify/react';
import pieChart2Fill from '@iconify/icons-eva/pie-chart-2-fill';
import peopleFill from '@iconify/icons-eva/people-fill';
import barChartIcon from '@iconify/icons-eva/bar-chart-2-fill';
import personOutline from '@iconify/icons-eva/person-outline';
import shoppingBagFill from '@iconify/icons-eva/shopping-bag-fill';
import fileTextFill from '@iconify/icons-eva/file-text-fill';
import lockFill from '@iconify/icons-eva/lock-fill';
import unlockOutline from '@iconify/icons-eva/unlock-outline';
import personAddFill from '@iconify/icons-eva/person-add-fill';
import alertTriangleFill from '@iconify/icons-eva/alert-triangle-fill';
import infoFill from '@iconify/icons-eva/info-fill';
import listOutline from '@iconify/icons-eva/list-outline';
import cloudDownloadOutline from '@iconify/icons-eva/cloud-download-outline';
import settingFill from '@iconify/icons-eva/settings-fill';
// ----------------------------------------------------------------------

const getIcon = (name) => <Icon icon={name} width={22} height={22} />;

const sidebarConfig = [
  {
    title: 'dashboard',
    path: '/dashboard/app',
    icon: getIcon(pieChart2Fill),
    roles: ['admin', 'superadmin', 'admin_opd', 'admin_guest']
  },
  {
    title: 'tracking',
    path: `/dashboard/services?page=1&size=${process.env.REACT_APP_PAGE_SIZE}`,
    icon: getIcon(listOutline),
    roles: ['admin', 'superadmin', 'admin_opd', 'admin_guest']
  },
  {
    title: 'layanan',
    path: '/dashboard/requests',
    icon: getIcon(cloudDownloadOutline),
    roles: ['admin_opd']
  },
  {
    title: 'user',
    path: '/dashboard/user',
    icon: getIcon(peopleFill),
    roles: ['admin', 'superadmin']
  },
  {
    title: 'UAT',
    path: '/dashboard/uat',
    icon: getIcon(fileTextFill),
    roles: ['admin', 'superadmin', 'admin_opd', 'developer']
  },
  {
    title: 'Aplikasi',
    path: '/dashboard/aplikasi',
    icon: getIcon(fileTextFill),
    roles: ['admin', 'superadmin', 'admin_opd', 'developer']
  },
  {
    title: 'reports',
    icon: getIcon(barChartIcon),
    roles: ['admin', 'superadmin', 'admin_guest'],
    children: [
      {
        title: 'rekomendasi',
        path: `/dashboard/reports/rekomendasi?page=1&size=${process.env.REACT_APP_PAGE_SIZE}&type=rekomendasi`,
        icon: getIcon(barChartIcon),
        roles: ['admin', 'superadmin', 'admin_guest']
      }
    ]
  },
  {
    title: 'Token',
    path: '/dashboard/token',
    icon: getIcon(unlockOutline),
    roles: ['admin', 'superadmin']
  },
  {
    title: 'profile',
    path: '/dashboard/profile',
    icon: getIcon(personOutline),
    roles: ['admin', 'superadmin', 'admin_opd']
  },
  {
    title: 'setting',
    path: '/dashboard/setting',
    icon: getIcon(settingFill),
    roles: ['admin', 'superadmin']
  },
  {
    title: 'manual',
    path: '/dashboard/manual',
    icon: getIcon(infoFill),
    roles: ['admin', 'superadmin', 'admin_opd']
  }
  // {
  //   title: 'product',
  //   path: '/dashboard/products',
  //   icon: getIcon(shoppingBagFill),
  //   roles: ['superadmin']
  // }
  // {
  //   title: 'blog',
  //   path: '/dashboard/blog',
  //   icon: getIcon(fileTextFill),
  //   roles: ['superadmin']
  // },
  // {
  //   title: 'login',
  //   path: '/login',
  //   icon: getIcon(lockFill),
  //   roles: ['superadmin']
  // },
  // {
  //   title: 'register',
  //   path: '/register',
  //   icon: getIcon(personAddFill),
  //   roles: ['superadmin']
  // },
  // {
  //   title: 'Not found',
  //   path: '/404',
  //   icon: getIcon(alertTriangleFill),
  //   roles: ['superadmin']
  // }
];

export default sidebarConfig;
